export const menuData = [
  {
    location: "primary",
    title: "Explore Ireland",
    link: "/explore-ireland",
  },
  {
    location: "primary",
    title: "Travelling",
    link: "/personal",
    childMenu: [
      {
        title: "Solo Travelling",
        link: "/personal/solo-trip",
      },
      {
        title: "Group Travelling",
        link: "/personal/group-trip",
      },
      {
        title: "Club Travelling",
        link: "/personal/club-trip",
      },
    ],
  },
  {
    location: "primary",
    title: "Local Advisors",
    link: "/ameegos",
    childMenu: [
      {
        title: "Local Ameego",
        link: "/ameegos/local",
      },
      {
        title: "National Ameego",
        link: "/ameegos/trip",
      },
      {
        title: "Specialist Ameego",
        link: "/ameegos/specialist",
      },
    ],
  },
  {
    location: "primary",
    title: "Destinations",
    link: "/destination-promoters",
  },
  {
    location: "primary",
    title: "Business",
    link: "/business",
  },
  { location: "secondary", title: "About", link: "/about" },
  { location: "secondary", title: "Contact", link: "/contact" },
  { location: "secondary", title: "FAQ", link: "/faq" },
];
